import React, { useState, useEffect, useRef } from 'react';
import { setupAuthListeners } from './authUtils';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import "./Navbar.css";
import 'animate.css';
import axios from 'axios';
import { FiGrid, FiUser, FiLogOut, FiMail } from 'react-icons/fi';




// --- Login Popup Component with Optimized Flow ---
function LoginPopup({ close, onLogin }) {

    const [currentMode, setCurrentMode] = useState('login');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [fullName, setFullName] = useState('');
    const [phone, setPhone] = useState('');
    const [dob, setDob] = useState('');
    const [dobYear, setDobYear] = useState('');
    const [dobMonth, setDobMonth] = useState('');
    const [dobDay, setDobDay] = useState('');
    const [otp, setOtp] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const navigate = useNavigate();
    const [resendTimer, setResendTimer] = useState(60);
    const [resendDisabled, setResendDisabled] = useState(true);







    const APP_NAME = process.env.REACT_APP_APP_NAME;
    const LOGIN_API_BASE = process.env.REACT_APP_LOGIN_APP_API_BASE;
    const REACT_APP_API_BASE = process.env.REACT_APP_API_BASE;

    const OTP_API_BASE = process.env.REACT_APP_OTP_BASE_URL;
    const [agreeToTerms, setAgreeToTerms] = useState(false);






    useEffect(() => {
        if (dobYear && dobMonth && dobDay) {
            const formattedMonth = String(dobMonth).padStart(2, '0');
            const formattedDay = String(dobDay).padStart(2, '0');
            const formattedDate = `${dobYear}-${formattedMonth}-${formattedDay}`;
            setDob(formattedDate);
        }
    }, [dobYear, dobMonth, dobDay]);

    const generateYearOptions = () => {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let year = currentYear; year >= currentYear - 100; year--) {
            years.push(<option key={year} value={year}>{year}</option>);
        }
        return years;
    };

    const generateMonthOptions = () => {
        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        return months.map((month, index) => (
            <option key={index + 1} value={index + 1}>{month}</option>
        ));
    };

    const generateDayOptions = () => {
        if (!dobYear || !dobMonth) return [];
        const daysInMonth = new Date(dobYear, dobMonth, 0).getDate();
        const days = [];
        for (let day = 1; day <= daysInMonth; day++) {
            days.push(<option key={day} value={day}>{day}</option>);
        }
        return days;
    };

    const showStyledAlert = (options) => {
        const SwalStyled = Swal.mixin({
            customClass: {
                popup: 'gn-swal-popup',
                title: 'gn-swal-title',
                htmlContainer: 'gn-swal-html-container',
                confirmButton: 'gn-swal-confirm-button',
            },
            buttonsStyling: false,
        });
        SwalStyled.fire({
            showClass: { popup: 'animate__animated animate__fadeInUp animate__faster' },
            hideClass: { popup: 'animate__animated animate__fadeOutDown animate__faster' },
            ...options
        });
    };

    useEffect(() => {
        if (error || message) {
            const timer = setTimeout(() => {
                setError('');
                setMessage('');
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [error, message]);

    useEffect(() => {
        let interval;
        if ((currentMode === 'login-verify-otp' || currentMode === 'signup-verify-otp') && resendDisabled) {
            setResendTimer(60);
            interval = setInterval(() => {
                setResendTimer(prevTimer => {
                    if (prevTimer <= 1) {
                        clearInterval(interval);
                        setResendDisabled(false);
                        return 0;
                    }
                    return prevTimer - 1;
                });
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [currentMode, resendDisabled]);

    const handleEnterPress = (event, action) => {
        if (event.key === 'Enter' && !loading) {
            event.preventDefault();
            action();
        }
    };

    const handleSubmit = () => {
        setError('');
        setMessage('');

        if (!agreeToTerms) {
            setError('You must agree to the Terms of Use and Privacy Policy.');
            return;
        }

        if (currentMode === 'login') {
            if (!email || !password) {
                setError('Email and password are required.');
                return;
            }
            const emailRegex = /\S+@\S+\.\S+/;
            if (!emailRegex.test(email)) {
                setError('Please enter a valid email address.');
                return;
            }

            setLoading(true);
            setCurrentMode('login-verify-otp');
            setResendDisabled(true);
            setMessage('An OTP has been sent to your email. Please verify.');

            axios.post(`${LOGIN_API_BASE}/api/send-email-otp`, { email, appName: APP_NAME })
                .catch((err) => {
                    const errorMessage = err.response?.data?.message || '';
                    if (errorMessage.includes('User not found for this app')) {
                        setCurrentMode('signup');
                        setPassword('');
                        setError('User not found. Please create an account.');
                        setMessage('');
                    } else {
                        setError(errorMessage || 'Login failed. Please try again.');
                        setCurrentMode('login');
                        setMessage('');
                    }
                })
                .finally(() => {
                    setLoading(false);
                });
            return;
        }

        setLoading(true);
        const performSubmit = async () => {
            try {
                if (currentMode === 'signup') {
                    if (!fullName || !phone || !email || !password || !dob) {
                        throw new Error('Please fill in all fields, including Date of Birth.');
                    }
                    const emailRegex = /\S+@\S+\.\S+/;
                    if (!emailRegex.test(email)) {
                        throw new Error('Please enter a valid email address.');
                    }
                    // --- PHONE VALIDATION ADDED HERE ---
                    const phoneRegex = /^[0-9]{10}$/;
                    if (!phoneRegex.test(phone)) {
                        throw new Error('Please enter a valid 10-digit phone number.');
                    }
                    // --- END PHONE VALIDATION ---
                    const formattedPhone = '+91' + phone.replace(/^(\+91)?/, '');
                    const nameParts = fullName.trim().split(/\s+/);
                    const firstName = nameParts.shift();
                    const lastName = nameParts.join(' ') || '';
                    const payload = { phone: formattedPhone, firstName, lastName, email, sender_id: 'GNVISA', template_id: '188004', appName: APP_NAME };
                    await axios.post(`${OTP_API_BASE}/api/send-otp`, payload);
                    setMessage('OTP sent to your phone. Please verify.');
                    setCurrentMode('signup-verify-otp');
                    setResendDisabled(true);
                } else if (currentMode === 'forgot-password') {
                    if (!email) {
                        throw new Error('Email is required.');
                    }
                    const emailRegex = /\S+@\S+\.\S+/;
                    if (!emailRegex.test(email)) {
                        throw new Error('Please enter a valid email address.');
                    }
                    await axios.post(`${LOGIN_API_BASE}/api/forgot-password-otp`, { email, appName: APP_NAME });
                    setMessage('If an account exists for this app, an OTP has been sent to your email.');
                    setCurrentMode('verify-otp');
                }
            } catch (err) {
                setError(err.response?.data?.message || err.message || 'An unexpected error occurred.');
            } finally {
                setLoading(false);
            }
        };
        performSubmit();
    };

    const handleSignupVerifyOtp = async () => {
        if (!otp) { setError('Please enter the OTP.'); return; }
        setLoading(true);
        setError('');
        setMessage('');
        try {
            const formattedPhone = '+91' + phone.replace(/^(\+91)?/, '');
            await axios.post(`${OTP_API_BASE}/api/verify-otp`, { phone: formattedPhone, otp, appName: APP_NAME });
            setMessage('OTP verified. Finalizing your registration...');
            const nameParts = fullName.trim().split(/\s+/);
            const firstName = nameParts.shift() || '';
            const lastName = nameParts.join(' ') || firstName;
            const signupPayload = { firstName, lastName, email, phone: formattedPhone, dob, password, appName: APP_NAME };
            const { data } = await axios.post(`${LOGIN_API_BASE}/api/save-signup`, signupPayload);
            if (data && data.userId) {
                const profileResponse = await axios.get(`${REACT_APP_API_BASE}/api/user/${data.userId}`);
                const fullUserData = profileResponse.data;
                onLogin(fullUserData, false);
                close();
                navigate('/myform');
            } else { throw new Error('Account creation failed or did not return a user ID.'); }
        } catch (err) {
            setError(err.response?.data?.message || err.message || 'An unexpected error occurred.');
        } finally { setLoading(false); }
    };

    const handleLoginVerifyOtp = async () => {
        if (!otp) { setError('Please enter the OTP.'); return; }
        setLoading(true);
        setError('');
        setMessage('');
        try {
            const loginResponse = await axios.post(`${LOGIN_API_BASE}/api/save-login`, { email, password, otp, appName: APP_NAME });
            const loginData = loginResponse.data;
            if (loginData && loginData.userId) {
                const [profileResult, formResult] = await Promise.allSettled([
                    axios.get(`${REACT_APP_API_BASE}/api/user/${loginData.userId}`),
                    axios.get(`${REACT_APP_API_BASE}/api/form/${loginData.userId}`)
                ]);
                if (profileResult.status === 'rejected') {
                    throw new Error('Failed to load user profile after login.');
                }
                const fullUserData = profileResult.value.data;
                const formExists = formResult.status === 'fulfilled' && formResult.value.data && formResult.value.data._id;
                onLogin(fullUserData, formExists);
                close();
                if (formExists) {
                    navigate('/dashboard');
                } else {
                    navigate('/myform');
                }
            } else {
                throw new Error(loginData.message || 'Login failed: Invalid response from server.');
            }
        } catch (err) {
            setError(err.response?.data?.message || err.message || 'An unexpected error occurred.');
        } finally {
            setLoading(false);
        }
    };

    const handleResendOtp = async () => {
        if (loading) return;
        setError('');
        setMessage('');
        setLoading(true);
        try {
            await axios.post(`${LOGIN_API_BASE}/api/send-email-otp`, { email, appName: APP_NAME });
            setMessage('A new OTP has been sent to your email.');
            setResendDisabled(true);
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to resend OTP.');
        } finally {
            setLoading(false);
        }
    };

    const handleResendSignupOtp = async () => {
        if (loading) return;
        setError('');
        setMessage('');
        setLoading(true);
        try {
            const formattedPhone = '+91' + phone.replace(/^(\+91)?/, '');
            const nameParts = fullName.trim().split(/\s+/);
            const firstName = nameParts.shift();
            const lastName = nameParts.join(' ') || '';
            const payload = { phone: formattedPhone, firstName, lastName, email, sender_id: 'GNVISA', template_id: '188004', appName: APP_NAME };
            await axios.post(`${OTP_API_BASE}/api/send-otp`, payload);
            setMessage('A new OTP has been sent to your phone.');
            setResendDisabled(true);
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to resend OTP.');
        } finally {
            setLoading(false);
        }
    };

    const handleVerifyResetOtp = async () => {
        if (!otp || !newPassword) {
            setError('Please enter the OTP and your new password.');
            return;
        }
        setLoading(true);
        setError('');
        setMessage('');
        try {
            await axios.post(`${LOGIN_API_BASE}/api/reset-password-otp`, { email, otp, password: newPassword, appName: APP_NAME });
            showStyledAlert({ icon: 'success', title: 'Success!', text: 'Your password has been reset successfully.' });
            setCurrentMode('login');
            setOtp('');
            setNewPassword('');
        } catch (err) {
            setError(err.response?.data?.message || err.message || 'An unexpected error occurred.');
        } finally {
            setLoading(false);
        }
    };

    const handleModeSwitch = () => {
        setError('');
        setMessage('');
        if (currentMode.startsWith('login')) {
            setCurrentMode('signup');
        } else {
            setCurrentMode('login');
        }
        setEmail('');
        setPassword('');
        setFullName('');
        setPhone('');
        setDob('');
        setDobDay('');
        setDobMonth('');
        setDobYear('');
        setOtp('');
        setAgreeToTerms(false);
    };

    const disclaimerCheckbox = (
        <div className="gn-disclaimer-group">
            <input
                type="checkbox"
                id="gn-terms"
                checked={agreeToTerms}
                onChange={(e) => setAgreeToTerms(e.target.checked)}
            />
            <label htmlFor="gn-terms">
                I agree to the <Link to="/terms" target="_blank" rel="noopener noreferrer">Terms of Use</Link> and <Link to="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</Link>.
            </label>
        </div>
    );

    return (
        <div className="gn-popup-overlay">
            <div className="gn-popup-box">
                <button className="gn-close-btn" onClick={close}>×</button>
                <div className="gn-popup-header">
                    <h2>{currentMode === 'login' ? 'Welcome Back' : currentMode === 'login-verify-otp' ? 'Verify Login OTP' : currentMode === 'signup' ? 'Create Account' : currentMode === 'signup-verify-otp' ? 'Verify Signup OTP' : currentMode === 'forgot-password' ? 'Forgot Password' : 'Reset Password'}</h2>
                    <p>{currentMode === 'login' ? 'Sign in to your account' : currentMode === 'login-verify-otp' ? `Enter the OTP sent to ${email}` : currentMode === 'signup' ? 'Join us today' : currentMode === 'signup-verify-otp' ? `Enter the OTP sent to your phone` : currentMode === 'forgot-password' ? 'Enter your email to receive an OTP' : 'Enter the OTP and your new password'}</p>
                </div>

                {error && <div className="gn-alert gn-alert-error">{error}</div>}
                {message && <div className="gn-alert gn-alert-success">{message}</div>}

                {currentMode === 'signup' && (
                    <div className="gn-auth-form animate-fade-up" style={{ animationDelay: '0.3s' }}>
                        <div className="gn-input-group"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg><input id="gn-fullName" type="text" placeholder=" " value={fullName} onChange={(e) => setFullName(e.target.value)} /><label htmlFor="gn-fullName">Full Name</label></div>
                        <div className="gn-input-group"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg><input id="gn-phone" type="tel" maxLength="10" placeholder=" " value={phone} onChange={(e) => setPhone(e.target.value)} /><label htmlFor="gn-phone">Phone Number</label></div>
                        <div className="gn-input-group"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg><input id="gn-email-signup" type="email" placeholder=" " value={email} onChange={(e) => setEmail(e.target.value)} /><label htmlFor="gn-email-signup">Email Address</label></div>
                        <div className="gn-input-group">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                            <label className="gn-dob-label">Date of Birth</label>
                            <div className="gn-dob-select-group">
                                <select value={dobYear} onChange={(e) => { setDobYear(e.target.value); setDobMonth(''); setDobDay(''); }} required><option value="" disabled>Year</option>{generateYearOptions()}</select>
                                <select value={dobMonth} onChange={(e) => { setDobMonth(e.target.value); setDobDay(''); }} disabled={!dobYear} required><option value="" disabled>Month</option>{generateMonthOptions()}</select>
                                <select value={dobDay} onChange={(e) => setDobDay(e.target.value)} disabled={!dobMonth} required><option value="" disabled>Day</option>{generateDayOptions()}</select>
                            </div>
                        </div>
                        <div className="gn-input-group"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg><input id="gn-password-signup" type="password" placeholder=" " value={password} onChange={(e) => setPassword(e.target.value)} onKeyDown={(e) => handleEnterPress(e, handleSubmit)} /><label htmlFor="gn-password-signup">Password</label></div>
                        {disclaimerCheckbox}
                        <button onClick={handleSubmit} className="gn-auth-btn" disabled={loading}>{loading ? 'Processing...' : 'Create Account'}</button>
                    </div>
                )}

                {currentMode === 'signup-verify-otp' && (
                    <div className="gn-auth-form">
                        <div className="gn-input-group">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 15l6-6m-4-2l2-2m-3 3l-3 3m-4-4l-4 4m-2-2l2-2"></path><circle cx="12" cy="12" r="7"></circle></svg>
                            <input id="gn-signupOtp" type="text" placeholder=" " value={otp} onChange={(e) => setOtp(e.target.value)} onKeyDown={(e) => handleEnterPress(e, handleSignupVerifyOtp)} />
                            <label htmlFor="gn-signupOtp">Enter OTP from your phone</label>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '10px 0', fontSize: '0.9rem' }}>
                            <p onClick={() => setCurrentMode('signup')} style={{ cursor: 'pointer', color: '#007bff', textDecoration: 'underline', margin: 0, padding: 0, background: 'none', border: 'none' }}>
                                ← Back to Signup
                            </p>
                            <div>
                                {resendDisabled ? (
                                    <span> Resend OTP in {resendTimer}s </span>
                                ) : (
                                    <button onClick={handleResendSignupOtp} disabled={loading} style={{ background: 'none', border: 'none', color: '#007bff', cursor: 'pointer', padding: 0, textDecoration: 'underline', font: 'inherit' }}>
                                        Resend OTP
                                    </button>
                                )}
                            </div>
                        </div>
                        <button onClick={handleSignupVerifyOtp} className="gn-auth-btn" disabled={loading}>
                            {loading ? 'Verifying...' : 'Verify & Complete Signup'}
                        </button>
                    </div>
                )}

                {currentMode === 'login' && (
                    <div className="gn-auth-form animate-fade-up" style={{ animationDelay: '0.3s' }}>
                        <div className="gn-input-group"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg><input id="gn-loginEmail" type="email" placeholder=" " value={email} onChange={(e) => setEmail(e.target.value)} /><label htmlFor="gn-loginEmail">Email Address</label></div>
                        <div className="gn-input-group"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg><input id="gn-loginPassword" type="password" placeholder=" " value={password} onChange={(e) => setPassword(e.target.value)} onKeyDown={(e) => handleEnterPress(e, handleSubmit)} /><label htmlFor="gn-loginPassword">Password</label></div>
                        {disclaimerCheckbox}
                        <button onClick={handleSubmit} className="gn-auth-btn" disabled={loading}>{loading ? 'Processing...' : 'Sign In'}</button>
                        <p className="gn-forgot-link" onClick={() => setCurrentMode('forgot-password')}>Forgot Password?</p>
                    </div>
                )}

                {currentMode === 'login-verify-otp' && (
                    <div className="gn-auth-form">
                        <div className="gn-input-group">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 15l6-6m-4-2l2-2m-3 3l-3 3m-4-4l-4 4m-2-2l2-2"></path><circle cx="12" cy="12" r="7"></circle></svg>
                            <input id="gn-otp" type="text" placeholder=" " value={otp} onChange={(e) => setOtp(e.target.value)} onKeyDown={(e) => handleEnterPress(e, handleLoginVerifyOtp)} />
                            <label htmlFor="gn-otp">Enter OTP from your email</label>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '10px 0', fontSize: '0.9rem' }}>
                            <p onClick={() => setCurrentMode('login')} style={{ cursor: 'pointer', color: '#007bff', textDecoration: 'underline', margin: 0, padding: 0, background: 'none', border: 'none' }}>
                                ← Back to Login
                            </p>
                            <div>
                                {resendDisabled ? (
                                    <span> Resend again in {resendTimer}s </span>
                                ) : (
                                    <button onClick={handleResendOtp} disabled={loading} style={{ background: 'none', border: 'none', color: '#007bff', cursor: 'pointer', padding: 0, textDecoration: 'underline', font: 'inherit' }}>
                                        Resend OTP
                                    </button>
                                )}
                            </div>
                        </div>
                        <button onClick={handleLoginVerifyOtp} className="gn-auth-btn" disabled={loading}>
                            {loading ? 'Verifying...' : 'Verify & Complete Login'}
                        </button>
                    </div>
                )}

                {currentMode === 'forgot-password' && (
                    <div className="gn-auth-form animate-fade-up" style={{ animationDelay: '0.3s' }}>
                        <div className="gn-input-group"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg><input id="gn-forgotEmail" type="email" placeholder=" " value={email} onChange={(e) => setEmail(e.target.value)} onKeyDown={(e) => handleEnterPress(e, handleSubmit)} /><label htmlFor="gn-forgotEmail">Email Address</label></div>
                        {disclaimerCheckbox}
                        <button onClick={handleSubmit} className="gn-auth-btn" disabled={loading}>{loading ? 'Sending...' : 'Send OTP'}</button>
                        <div className="gn-auth-switch"><p onClick={() => setCurrentMode('login')}><span className="gn-switch-link" style={{ textDecoration: "none" }}>← Back to Login</span></p></div>
                    </div>
                )}

                {currentMode === 'verify-otp' && (
                    <div className="gn-auth-form animate-fade-up" style={{ animationDelay: '0.3s' }}>
                        <div className="gn-input-group"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 15l6-6m-4-2l2-2m-3 3l-3 3m-4-4l-4 4m-2-2l2-2"></path><circle cx="12" cy="12" r="7"></circle></svg><input id="gn-resetOtp" type="text" placeholder=" " value={otp} onChange={(e) => setOtp(e.target.value)} /><label htmlFor="gn-resetOtp">Enter OTP from email</label></div>
                        <div className="gn-input-group"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg><input id="gn-newPassword" type="password" placeholder=" " value={newPassword} onChange={(e) => setNewPassword(e.target.value)} onKeyDown={(e) => handleEnterPress(e, handleVerifyResetOtp)} /><label htmlFor="gn-newPassword">New Password</label></div>
                        <button onClick={handleVerifyResetOtp} className="gn-auth-btn" disabled={loading}>{loading ? 'Verifying...' : 'Reset Password'}</button>
                        <div className="gn-auth-switch"><p onClick={() => setCurrentMode('login')}><span className="gn-switch-link" style={{ textDecoration: "none" }}>← Back to Login</span></p></div>
                    </div>
                )}

                {(currentMode === 'login' || currentMode === 'signup') && (
                    <div className="gn-auth-switch animate-fade-up" style={{ animationDelay: '0.4s' }}>
                        <p onClick={handleModeSwitch}>{currentMode === 'login' ? "Don't have an account? " : "Already have an account? "}<span className="gn-switch-link">{currentMode === 'login' ? 'Sign up' : 'Sign in'}</span></p>
                    </div>
                )}
            </div>
        </div>
    );
}


// --- Main Navbar Component ---
function Navbar({ onLogout }) {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [profileData, setProfileData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const [hasForm, setHasForm] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [activeLink, setActiveLink] = useState(location.pathname);

const handleMobileNavClickWithScrollFix = (path) => {
  setMobileMenuOpen(false);
  document.body.classList.remove('mobile-menu-open');
  document.body.style.overflow = 'auto';

  setTimeout(() => {
    window.scrollTo(0, 0);           // Scroll to top
    window.scrollBy(0, 1);           // iOS Safari reflow fix
    window.scrollBy(0, -1);
    navigate(path);                  // Navigate to route
  }, 100); // Slight delay ensures the menu has closed first
};




    useEffect(() => {
        setActiveLink(location.pathname);
    }, [location.pathname]);

    const isDashboardPage = location.pathname.startsWith('/dashboard');

    const initializeAuth = () => {
        setLoading(true);
        const isLoggedIn = localStorage.getItem('isLoginTrue') === 'true';
        const userId = localStorage.getItem('userId');
        const storedHasForm = localStorage.getItem('hasForm') === 'true';

        if (isLoggedIn && userId) {
            setLoggedIn(true);
            fetchProfileData(userId);
            setHasForm(storedHasForm);
        } else {
            setLoggedIn(false);
            setProfileData(null);
            setHasForm(false);
        }
        setLoading(false);
    };

    const fetchProfileData = async (userId) => {
        if (!userId) return;
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE}/api/user/${userId}`);
            setProfileData(response.data);
        } catch (error) {
            console.error("Failed to fetch profile data for navbar:", error);
            handleLogout();
        }
    };

    const handleLogin = (userData, formExists) => {
        localStorage.setItem('isLoginTrue', 'true');
        localStorage.setItem('userId', userData.userId);
        localStorage.setItem('currentUser', JSON.stringify(userData));
        localStorage.setItem('hasForm', formExists ? 'true' : 'false');

         window.dispatchEvent(new CustomEvent('loginStateChange'));

        setLoggedIn(true);
        setProfileData(userData);
        setHasForm(formExists);
    };

    useEffect(() => {
        setMobileMenuOpen(false);
        setShowPopup(false);
        setIsDropdownOpen(false);

        // 🧠 iOS re-render force
        setTimeout(() => {
            document.body.style.overflow = 'auto';
            window.scrollBy(0, 1);
            window.scrollBy(0, -1);
        }, 50);
    }, [location.pathname]);



    const handleLogout = () => {
        localStorage.removeItem('isLoginTrue');
        localStorage.removeItem('userId');
        localStorage.removeItem('currentUser');
        localStorage.removeItem('hasForm');

        window.dispatchEvent(new CustomEvent('loginStateChange'));

        setProfileData(null);
        setLoggedIn(false);
        setHasForm(false);
        setMobileMenuOpen(false);
        setIsDropdownOpen(false);

        // 🧠 Ensure scroll re-enabled (in case popup/sidebar was open)
        document.body.style.overflow = 'auto';

        if (onLogout) {
            onLogout();
        }
    };


    const handleNavigation = (path) => {
        setIsDropdownOpen(false);
        if (hasForm) {
            navigate(path);
        } else {
            Swal.fire({
                icon: 'info',
                title: 'Complete Your Form First',
                text: 'Please fill out and save your form to access this section.',
                confirmButtonText: 'Go to My Form',
                showCancelButton: true,
                cancelButtonText: 'Later'
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate('/myform');
                }
            });
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);

        const handleFormSaved = () => {
            console.log("Navbar received the 'formSaved' event. Unlocking buttons.");
            setHasForm(true);
        };

        initializeAuth();
        const cleanupAuthListeners = setupAuthListeners((isAuth) => {
            if (!isAuth) handleLogout();
        });

        const handleStorageChange = (event) => {
            if (['isLoginTrue', 'currentUser', 'userId', 'hasForm'].includes(event.key)) {
                initializeAuth();
            }
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('formSaved', handleFormSaved);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            cleanupAuthListeners();
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('formSaved', handleFormSaved);
        };
    }, []);

    const fullName = profileData ? `${profileData.firstName || ''} ${profileData.lastName || ''}`.trim() : '';

    useEffect(() => {
        const triggerButtons = document.querySelectorAll('.trigger-login-popup');
        const handleClick = () => setShowPopup(true);
        triggerButtons.forEach((btn) => {
            btn.addEventListener('click', handleClick);
        });
        return () => {
            triggerButtons.forEach((btn) => {
                btn.removeEventListener('click', handleClick);
            });
        };
    }, [location.pathname]);

    return (
        <>
            <div className="gn-top-bar"></div>
            <nav className="gn-navbar">
                <div className="gn-logo">
                    <Link to="/"><img src="/photos/heading.png" alt="Visa Predictor" loading="lazy" /></Link>
                </div>
                <div className="gn-nav-right-group">
                    <ul className="gn-nav-links">
                        <li><Link to="/" className={activeLink === '/' ? 'gn-active-link' : ''}>Home</Link></li>
                        <li><Link to="/About" className={activeLink === '/About' ? 'gn-active-link' : ''}>About Us</Link></li>
                        <li><Link to="/Itwork" className={activeLink === '/Itwork' ? 'gn-active-link' : ''}>How It Works</Link></li>
                        <li><Link to="/Pricing" className={activeLink === '/Pricing' ? 'gn-active-link' : ''}>Pricing</Link></li>
                        <li><Link to="/Contact" className={activeLink === '/Contact' ? 'gn-active-link' : ''}>Contact</Link></li>
                    </ul>

                    <div className={`gn-nav-auth ${isDashboardPage ? 'on-dashboard-mobile' : ''}`}>
                        {loading ? (
                            <div className="gn-loading-spinner"></div>
                        ) : loggedIn && profileData ? (
                            <div className="gn-profile-container" ref={dropdownRef}>
                                <div className="gn-profile-icon" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                                    {profileData.avatarUrl ? (
                                        <img src={profileData.avatarUrl} alt="AI Visa Predictor" className="profile-avatar" loading="lazy" />
                                    ) : (
                                        fullName ? fullName.charAt(0).toUpperCase() : 'U'
                                    )}
                                </div>
                                {isDropdownOpen && (
                                    <div className="gn-profile-dropdown">
                                        <div className="gn-dropdown-user-info">
                                            <FiMail className="gn-user-info-icon" />
                                            <span>{profileData.email}</span>
                                        </div>
                                        <div className="gn-dropdown-actions">
                                            <button className="gn-dropdown-action-btn" onClick={() => handleNavigation('/dashboard')}>
                                                <FiGrid />
                                                <span>Dashboard</span>
                                            </button>
                                            <button className="gn-dropdown-action-btn" onClick={() => handleNavigation('/dashboard?view=profile')}>
                                                <FiUser />
                                                <span>My Profile</span>
                                            </button>
                                            <button className="gn-dropdown-action-btn gn-logout-btn" onClick={handleLogout}>
                                                <FiLogOut />
                                                <span>Logout</span>
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <button className="gn-login-btn" onClick={() => setShowPopup(true)}>Get My Report</button>
                        )}
                    </div>

                    {!isDashboardPage && (
                        <div className="gn-mobile-toggle" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    )}
                </div>
            </nav>

            {/* New Sidebar Implementation */}
            <div className={`gn-mobile-overlay ${mobileMenuOpen ? 'gn-active' : ''}`} onClick={() => setMobileMenuOpen(false)}></div>
            <div className={`gn-mobile-sidebar ${mobileMenuOpen ? 'gn-active' : ''}`}>
                <button
                    className="gn-close-sidebar"
                    onClick={() => {
                        setMobileMenuOpen(false);
                        document.body.style.overflow = 'auto'; // force scroll unlock
                    }}
                >×</button>

                <ul className="gn-mobile-nav-links">
                    <li>
                        <a
                            href="/"
                            className={activeLink === '/' ? 'gn-active-link' : ''}
                            onClick={(e) => {
                                e.preventDefault();
                                handleMobileNavClickWithScrollFix('/');
                            }}
                        >Home</a>
                    </li>
                    <li>
                        <a
                            href="/About"
                            className={activeLink === '/About' ? 'gn-active-link' : ''}
                            onClick={(e) => {
                                e.preventDefault();
                                handleMobileNavClickWithScrollFix('/About');
                            }}
                        >About Us</a>
                    </li>
                    <li>
                        <a
                            href="/Itwork"
                            className={activeLink === '/Itwork' ? 'gn-active-link' : ''}
                            onClick={(e) => {
                                e.preventDefault();
                                handleMobileNavClickWithScrollFix('/Itwork');
                            }}
                        >How It Works</a>
                    </li>
                    <li>
                        <a
                            href="/Pricing"
                            className={activeLink === '/Pricing' ? 'gn-active-link' : ''}
                            onClick={(e) => {
                                e.preventDefault();
                                handleMobileNavClickWithScrollFix('/Pricing');
                            }}
                        >Pricing</a>
                    </li>
                    <li>
                        <a
                            href="/Contact"
                            className={activeLink === '/Contact' ? 'gn-active-link' : ''}
                            onClick={(e) => {
                                e.preventDefault();
                                handleMobileNavClickWithScrollFix('/Contact');
                            }}
                        >Contact</a>
                    </li>
                </ul>



                <div className="gn-mobile-auth-section">
                    {loading ? (
                        <div style={{ textAlign: 'center', padding: '1rem' }}><div className="gn-loading-spinner"></div></div>
                    ) : !loggedIn && (
                        <button className="gn-login-btn" onClick={() => { setShowPopup(true); setMobileMenuOpen(false); }}>Get My Report</button>
                    )}
                </div>
            </div>

            {showPopup && (
                <LoginPopup close={() => setShowPopup(false)} onLogin={handleLogin} />
            )}
        </>
    );
}

export default Navbar;